var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHitLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.33329 6.00007H3.33329V14.0001H1.33329C1.15648 14.0001 0.986912 13.9298 0.861888 13.8048C0.736864 13.6798 0.666626 13.5102 0.666626 13.3334V6.66674C0.666626 6.48993 0.736864 6.32036 0.861888 6.19534C0.986912 6.07031 1.15648 6.00007 1.33329 6.00007ZM4.86196 5.13807L9.12863 0.871408C9.18533 0.814537 9.26067 0.780052 9.34077 0.774295C9.42088 0.768539 9.50037 0.791897 9.56463 0.840074L10.1333 1.26674C10.2912 1.3853 10.4105 1.54798 10.4761 1.73424C10.5417 1.92051 10.5507 2.12204 10.502 2.31341L9.73329 5.33341H14C14.3536 5.33341 14.6927 5.47388 14.9428 5.72393C15.1928 5.97398 15.3333 6.31312 15.3333 6.66674V8.06941C15.3335 8.24365 15.2995 8.41623 15.2333 8.57741L13.17 13.5874C13.1196 13.7096 13.0341 13.814 12.9243 13.8875C12.8145 13.9609 12.6854 14.0001 12.5533 14.0001H5.33329C5.15648 14.0001 4.98691 13.9298 4.86189 13.8048C4.73686 13.6798 4.66663 13.5102 4.66663 13.3334V5.60941C4.66666 5.43261 4.73693 5.26307 4.86196 5.13807Z",
    fill: "#343941"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitLike);
export default __webpack_public_path__ + "static/media/hit_like.d4da60db7977959414e691ff9e630b6f.svg";
export { ForwardRef as ReactComponent };